import { MultimediaView } from 'features/projects';

const MultimediaPage = () => <MultimediaView />;

export default MultimediaPage;
